import React from "react";

const StatisticItem = ({name,number}) => {
  return (
    <span className="flex flex-row w-full justify-between text-12 px-5 text-dark-blue-200   ">
      <p className="text-12 text-dark-blue-200 leading-5 font-normal">{name}</p>
      <span className="text-12 text-dark-blue-200">{number}</span>
    </span>
  );
};

export default StatisticItem;
